const getProductHeroUnitPriceLabel = (entry) => {
  if (!entry) return '';
  if (typeof entry === 'string') return entry;
  if (window.__vioneersPdpQuantity === 6 && entry.discountedLabel) return entry.discountedLabel;
  return entry.label || '';
};

const updateProductHeroUnitPrice = (sectionId, variantId) => {
  const el = document.getElementById(`ProductHeroUnitPrice-${sectionId}`);
  const mapEl = document.getElementById(`VariantUnitPriceMap-${sectionId}`);
  if (!mapEl || !variantId) return;
  let map = {};
  try {
    map = JSON.parse(mapEl.textContent);
  } catch (e) {
    return;
  }
  const entry = map[String(variantId)];
  const label = getProductHeroUnitPriceLabel(entry);
  if (el) {
    const inner = el.querySelector('.product-hero_unit-price-inner');
    if (label && inner) {
      inner.textContent = label;
      el.removeAttribute('hidden');
    } else {
      if (inner) inner.textContent = '';
      el.setAttribute('hidden', '');
    }
  }

  const singleCardUnit = document.getElementById(`VariantCardUnitSingle-${sectionId}`);
  const boxCardUnit = document.getElementById(`VariantCardUnitBox-${sectionId}`);
  if (singleCardUnit) singleCardUnit.textContent = entry && entry.label ? `(${entry.label})` : '';
  if (boxCardUnit) boxCardUnit.textContent = entry && entry.discountedLabel ? `(${entry.discountedLabel})` : '';
};

window.addEventListener('qty-price-update', (event) => {
  window.__vioneersPdpQuantity = event.detail && event.detail.quantity ? event.detail.quantity : 1;
  document.querySelectorAll('[id^="VariantUnitPriceMap-"]').forEach((mapEl) => {
    const sectionId = mapEl.id.replace('VariantUnitPriceMap-', '');
    const variantInput = document.querySelector(`#product-form-${sectionId} input[name="id"]`);
    if (variantInput) updateProductHeroUnitPrice(sectionId, variantInput.value);
  });
});

class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }
  
    onVariantChange() {
      this.updateOptions();
      this.updateVariantLegend();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
  
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
  
      const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
      mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));
  
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }
  
    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;
  
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }
  
    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
  
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
  
    renderProductInfo() {
      const formattedPrice = this.formatVariantPrice(this.currentVariant);

      const setPriceDisplay = (text) => {
        const container = document.getElementById(`price-${this.dataset.section}`);
        if (!container) return;
        const span = container.querySelector('.heading-large.is-price, .is-price');
        if (span) span.textContent = text;
        container.classList.remove('visibility-hidden');
      };

      const setHeroUnitPrice = () => {
        if (!this.currentVariant) return;
        updateProductHeroUnitPrice(this.dataset.section, this.currentVariant.id);
      };

      // Update main price from current variant only (do not overwrite with fetch HTML – section often re-renders with default variant)
      if (formattedPrice) setPriceDisplay(formattedPrice);
      setHeroUnitPrice();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
            || html.querySelector('[id^="price-"]')
            || html.querySelector('.heading-large.is-price')?.closest('div');
          let priceText = formattedPrice;
          if (source) {
            const priceEl = source.querySelector('.heading-large.is-price, .is-price');
            if (priceEl) priceText = priceEl.textContent.trim();
          }
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, true, priceText);
        })
        .catch(() => {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, true, formattedPrice);
        });
    }

    formatVariantPrice(variant) {
      if (!variant || variant.price == null) return '';
      const currency = this.dataset.currency || 'EUR';
      try {
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency }).format(variant.price / 100);
      } catch {
        return `${(variant.price / 100).toFixed(2).replace('.', ',')} €`;
      }
    }
  
    toggleAddButton(disable = true, text, modifyClass = true, priceText = '') {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] span');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text && addButtonText) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        if (addButtonText) {
          addButtonText.textContent = priceText || '';
        }
      }

      if (!modifyClass) return;
    }
  
    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      if (!button) return;
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const unitPriceEl = document.getElementById(`ProductHeroUnitPrice-${this.dataset.section}`);
      if (!addButton) return;
      if (addButtonText) addButtonText.textContent = window.variantStrings.unavailable;
      addButton.setAttribute('disabled', 'disabled');
      if (price) price.classList.add('visibility-hidden');
      if (unitPriceEl) unitPriceEl.setAttribute('hidden', '');
    }
  
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    updateVariantLegend() {}
  }
  
  customElements.define('variant-selects', VariantSelects);

  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }

    updateVariantLegend() {
      const fieldsets = this.querySelectorAll('fieldset');
      fieldsets.forEach((fieldset, i) => {
        const legend = fieldset.querySelector('.variant-card-legend, legend');
        if (legend && this.options && this.options[i]) {
          const optionName = legend.getAttribute('data-option-name') || 'Menge';
          legend.textContent = `${optionName}: ${this.options[i]}`;
        }
      });
    }
  }
  
  customElements.define('variant-radios', VariantRadios);